export function Spinner() {
  return (
    <div className="spinner-container">
      <div className="spinner-child"></div>
      <div className="spinner-child"></div>
      <div className="spinner-child"></div>
      <div className="spinner-child"></div>
      <div className="spinner-child"></div>
      <div className="spinner-child"></div>
    </div>
  )
}
